import {Link} from "react-router-dom"
import React, {useState} from "react"
import {
    getGlobalMoneyObject, getPathAndQueryParams,
    getTimeNumberFromZeroDateBeforeYesterday,
    getTimeNumberFromZeroDateMonth,
    getTimeNumberFromZeroDateThreeDay,
    getTimeNumberFromZeroDateToday,
    getTimeNumberFromZeroDateWeek,
    getTimeNumberFromZeroDateYesterday, objectLang
} from "../functions"
import {createBrowserHistory} from "history"
import {Button} from "react-bootstrap"
import {ViewWindowPurchase} from "./ViewWindowPurchase"

export const MoneyNav = ({dataNav}) => {

    let data = dataNav ? dataNav : getGlobalMoneyObject().nav

    const [show, setShow] = useState(false)
    const [purchases, setPurchases] = useState([])
    const [totalOfPeriod, setTotalOfPeriod] = useState(0)
    const [averageOfPeriod, setAverageOfPeriod] = useState(0)
    const [title, setTitle] = useState('Title')
    const lang = objectLang().language
    const l = lang.lang

    let selectButtonClass = 'fa-solid fa-bag-shopping',
        calc = new URLSearchParams(window.location.search).get('calculation')

    if (calc === 'payment_date') {
        selectButtonClass = `fa-regular fa-credit-card`
    }
    if (calc === 'purchase_date') {
        selectButtonClass = `fa-solid fa-cart-shopping`
    }

    const changePerHandler = (event) => {
        setShow(true)
        const nodes = document.querySelector('#select-period').childNodes
        for (const node in nodes) {
            if (event.target.value === nodes[node].value) {
                setTitle(nodes[node].innerHTML)
            }
        }
        const periods = {
            0: 'select',
            1: 'today',
            2: 'yesterday',
            3: 'before yesterday',
            4: 'three days',
            5: 'week',
            6: 'month',
        }
        const period = periods[event.target.value]
        const expenses = getGlobalMoneyObject().expenses
        const arr = []
        let total = 0, average
        switch (period) {
            case 'select':
                return setPurchases(arr)

            case 'today':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateToday().start && purchase < getTimeNumberFromZeroDateToday().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                setAverageOfPeriod(0)
                return setPurchases(arr)
            case 'yesterday':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateYesterday().start && purchase < getTimeNumberFromZeroDateYesterday().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                setAverageOfPeriod(0)
                return setPurchases(arr)

            case 'before yesterday':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateBeforeYesterday().start && purchase < getTimeNumberFromZeroDateBeforeYesterday().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                setAverageOfPeriod(0)
                return setPurchases(arr)

            case 'three days':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateThreeDay().start && purchase < getTimeNumberFromZeroDateThreeDay().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                average = total / 3
                setAverageOfPeriod(Number(average.toFixed(2)))
                return setPurchases(arr)

            case 'week':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateWeek().start && purchase < getTimeNumberFromZeroDateWeek().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                average = total / 7
                setAverageOfPeriod(Number(average.toFixed(2)))
                return setPurchases(arr)

            case 'month':
                for (const exp in expenses) {
                    const purchase = expenses[exp]['purchase_date']
                    if (purchase > getTimeNumberFromZeroDateMonth().start && purchase < getTimeNumberFromZeroDateMonth().end) {
                        arr.push(expenses[exp])
                        total += expenses[exp]['value']
                    }
                }
                setTotalOfPeriod(Number(total.toFixed(2)))
                average = total / 30
                setAverageOfPeriod(Number(average.toFixed(2)))
                return setPurchases(arr)

            default:
                return setPurchases(arr)
        }
    }

    const periods = [
        [0, lang.body.moneyPage.periods.per],
        [1, lang.body.moneyPage.periods.today],
        [2, lang.body.moneyPage.periods.yesterday],
        [3, lang.body.moneyPage.periods.beforeYesterday],
        [4, lang.body.moneyPage.periods.threeDays],
        [5, lang.body.moneyPage.periods.week],
        [6, lang.body.moneyPage.periods.month]
    ]

    if (show) {
        return (
            <>
                <ViewWindowPurchase
                    title={title}
                    totalOfPeriod={totalOfPeriod}
                    averageOfPeriod={averageOfPeriod}
                    currency={getGlobalMoneyObject()['currency']}
                    show={show}
                    setShow={setShow}
                    purchases={purchases}
                    setPurchases={setPurchases}
                    dataNav={dataNav}
                />
            </>
        )
    }
    return (
        <>
            <div className={'container m-auto w-100'}>
                <div className={'mb-2 col d-flex flex-nowrap justify-content-between justify-content-sm-center'}>
                    {data.isMain && <Link id={'to-main'}
                                              to={'/'}
                                              type={'button'}
                                              className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center fw-bold'}>
                        <i className="fa-solid fa-house"/>
                    </Link>}
                    {data.isMoney && <Link id={'to-money'}
                                               to={data.pathBack}
                                               type={'button'}
                                               className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center fw-bold'}>
                        <i className={'fa-solid fa-arrow-left'}/>
                    </Link>}
                    {data.isSetting && <Link id={'settings'}
                                                 to={`/${l}/money/settings`}
                                                 type={'button'}
                                                 className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center fw-bold'}>
                        <i className="fa-solid fa-sliders"/>
                    </Link>}
                    {data.isAddIncome && <Link id={'add-income'}
                                                   to={`/${l}/money/add-income`}
                                                   type={'button'}
                                                   className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-success m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center text-white fw-bold'}>
                        <i className="fa-solid fa-hand-holding-dollar"/>
                    </Link>}
                    {data.isAddPurchase && <Link id={'add-expense-purchase'}
                                                     to={`/${l}/money/add-expense?type=purchase`}
                                                     type={'button'}
                                                     className={'col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-warning m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center text-dark fw-bold'}>
                        <i className="fa-solid fa-bag-shopping"/>
                    </Link>}
                    {data.isYearDetail && <Button id={'select-calculation'}
                                                      type={'button'}
                                                      onClick={(e) => {
                                                          const history = createBrowserHistory()
                                                          const urlParams = new URLSearchParams(window.location.search)
                                                          const calculation = urlParams.get('calculation')
                                                          if (calculation) {
                                                              if (calculation === 'purchase_date') {
                                                                  urlParams.set('calculation', 'payment_date')
                                                              }
                                                              if (calculation === 'payment_date') {
                                                                  urlParams.set('calculation', 'purchase_date')
                                                              }
                                                          }
                                                          history.push(`${history.location.pathname}?${urlParams.toString()}`)
                                                          window.location.replace(getPathAndQueryParams())
                                                      }}
                                                      className={`col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-info m-1 fs-5 p-sm-1 p-2 d-flex align-items-center justify-content-center text-dark fw-bold`}>
                        <i className={selectButtonClass}/>
                    </Button>}
                    {data.isSelectPeriod && <select id={'select-period'}
                                                        className={`col col-md-2 col-lg-2 col-sm-3 col-2 btn btn-light m-1 fs-6 p-sm-1 p-2 d-flex align-items-center justify-content-center text-dark fw-bold`}
                                                        onChange={changePerHandler}
                                                        defaultValue={0}>
                        {periods.map((per, index) => {
                            return <option className={'bg-light'} value={per[0]} key={index}>{per[1]}</option>
                        })}
                    </select>}
                </div>
            </div>
        </>
    )
}

